import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

export const CustomTooltip = styled((props: TooltipProps) => (
  <Tooltip
    {...props}
    PopperProps={{
      popperOptions: {
        strategy: "fixed",
      },
      modifiers: [
        {
          name: "preventOverflow",
          enabled: false,
        },
      ],
    }}
    classes={{ popper: props.className }}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: "#fff",
    fontSize: 12,
    padding: "4px 8px",
    maxWidth: 200,
    textAlign: "center",
    pointerEvents: "none",
  },
}));

